/**
 * @desc 根据token获取用户信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(): Promise<BaseResponse<defs.ResultBean<defs.SysUserEntityObject>>> {
  return fetch({
    url: config.API_HOST + '/auth/findUserByToken',
    data: undefined,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
